/**
 * Keeps dashing-ui's component overrides in sync with the current brand.
 * Today: just `VisionPrediction.topPerformingMediaUrl`.
 */

// Side-effect import — loads dashing-ui's augmentation of
// `DashingUIOverrideRegistry` so the `setDashingUIOverrides` call below is typed.
import '@dashhudson/dashing-ui/vision-prediction';
import { setDashingUIOverrides } from '@dashhudson/dashing-ui/plugin';
import { watch } from 'vue';

import { useIdentityStore } from '@/stores/identity';

// Library, filtered to top + above-average predictions, sorted by predicted performance desc.
function topPerformingMediaUrlFor(brandLabel: string): string {
  const params = new URLSearchParams({ performance: 'top,high', sort: '-PERFORMANCE' });
  return `/${brandLabel}/library/discover?${params.toString()}`;
}

export default {
  install() {
    const identityStore = useIdentityStore();

    watch(
      () => identityStore.currentBrandLabel,
      (brandLabel) => {
        setDashingUIOverrides('vision-prediction', {
          topPerformingMediaUrl: brandLabel ? topPerformingMediaUrlFor(brandLabel) : undefined,
        });
      },
      { immediate: true },
    );
  },
};
